export default __webpack_public_path__ + "static/ToyotaUsedCars_horiz_black-5f816770be7c966d11fbcff9e4a71fc1.png";